/*
 * Public API Surface of deals
 */

export * from './lib/deals.service';
export * from './lib/deals.component';
export * from './lib/deals.module';
